module.exports = __webpack_public_path__ + "static/media/logo.22c44d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 377
// module chunks = 0